import Button from "@restart/ui/esm/Button";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { setAlert } from "../../store/actions/alertActions";
import { connect } from "react-redux";
import Alert from "../../components/alert/Alert";
import "./Dashboard.css";
import { Redirect } from "react-router";
import {
  getNote,
  postNote,
  editNote,
} from "../../store/actions/dashboardActions";

function Dashboard({
  setAlert,
  alerts,
  auth,
  dashboard,
  getNote,
  postNote,
  editNote,
}) {
  const [key, setKey] = useState("");

  const defaultState = {
    note: "",
    nominee1: "",
    nominee2: "",
    nominee3: "",
  };
  const [fields, setFields] = useState(defaultState);
  
  useEffect(() => {
    if (!dashboard.loading && dashboard.text) {
      if (auth.data) {
        const { nominee1, nominee2, nominee3 } = auth.data;
        setFields((prev) => ({
          ...prev,
          note: dashboard.text,
          nominee1,
          nominee2,
          nominee3,
        }));
      }
    }
  }, [dashboard]);

  const onChange = (event) => {
    const fieldName = event.target.name;
    const value = event.target.value;
    setFields((prev) => ({ ...prev, [fieldName]: value }));
  };

  if (auth.loading || dashboard.loading) {
    return "Loading....";
  }

  if (!auth.success) {
    return <Redirect to="/login" />;
  }

  var firstFill = !auth.data.filledDetails;

  const onClick = (e) => {
    e.preventDefault();

    const { nominee1, nominee2, nominee3, note } = fields;

    if (nominee1 === "" || nominee2 === "" || nominee3 === "" || note === "") {
      setAlert("Please fill out every shown field", 3, "error");
      return;
    }

    if (firstFill) {
      postNote(
        auth.token,
        key,
        fields.note,
        fields.nominee1,
        fields.nominee2,
        fields.nominee3
      );

      firstFill = false;
    } else {
      // Edit Note...
      editNote(
        auth.token,
        key,
        fields.note,
        fields.nominee1,
        fields.nominee2,
        fields.nominee3
      );

      firstFill = false;
    }
  };

  const onKeyChange = (e) => {
    setKey(e.target.value);
  };

  const onSubmitKey = (e) => {
    e.preventDefault();

    if (key === "") {
      alert("Please provide a secret key!");
      return;
    }

    getNote(auth.token, key);
  };

  if (!dashboard.success && !firstFill) {
    return (
      <div className="dashboard">
        <Alert alerts={alerts} />
        <h3 className="title">Welcome Back, {auth.data.name}</h3>
        <hr />

        <div className="note-div">
          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Enter Secret Key
            </Form.Label>
            <Col sm="10">
              <Form.Control value={key} onChange={onKeyChange} required />
            </Col>
          </Form.Group>
          <br />
          <button onClick={onSubmitKey}>Submit</button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <Alert alerts={alerts} />
      <h3 className="title">Welcome Back, {auth.data.name}</h3>
      <hr />

      <div className="note-div">
        <h4>Your Note</h4>
        <br />
        <Form className="note-form">
          <Form.Control
            className="note-box"
            value={fields.note}
            as="textarea"
            name="note"
            onChange={onChange}
          />
        </Form>
      </div>

      <div className="nominees-div">
        <h4>Nominees</h4>
        <br />
        <Form>
          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Nominee #1
            </Form.Label>
            <Col sm="10">
              <Form.Control
                defaultValue="email@example.com"
                name="nominee1"
                onChange={onChange}
                value={fields.nominee1}
              />
            </Col>
          </Form.Group>
          <br />

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Nominee #2
            </Form.Label>
            <Col sm="10">
              <Form.Control
                defaultValue="email@example.com"
                name="nominee2"
                onChange={onChange}
                value={fields.nominee2}
              />
            </Col>
          </Form.Group>
          <br />

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Nominee #3
            </Form.Label>
            <Col sm="10">
              <Form.Control
                defaultValue="email@example.com"
                name="nominee3"
                onChange={onChange}
                value={fields.nominee3}
              />
            </Col>
          </Form.Group>
        </Form>
      </div>

      <div className="nominees-div">
        <h4>Secret Key</h4>
        <br />

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Enter Secret Key
          </Form.Label>
          <Col sm="10">
            <Form.Control value={key} onChange={onKeyChange} required />
          </Col>
        </Form.Group>
      </div>

      <br />

      <Button onClick={onClick} className="save-btn" type="submit">
        Save Changes
      </Button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  alerts: state.alert,
  auth: state.auth,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps, {
  setAlert,
  getNote,
  postNote,
  editNote,
})(Dashboard);
